/**
 * @title renew-membership.js: Sub-module for Account pages
 * @description This module is used to handle renew membership tasks
 * @dependency
 */
define(['utilityGlobal', 'memberVerification', 'creditcard', 'applicationAffiliateForm', 'membershipHelper'], function(util, verification, creditcard, affForm, helper) {
  let RenewMembership = {
    sessionId: '',
    authToken: '',
    membershipData: {},
    getForm: function() {
      return $('#StorePaymentForm');
    },
    renewCreditCardData:{},
    cybersourceEnabled : false,
    /**
     * Initialization of the module.
     * @return {void} [description]
     */
    init: function() {
      /**
       * From AccountRenewMembership_Data.jsp
       * @type {Object}
       */
    	//feature flag for cybersource
      this.cybersourceEnabled = $("#cybersourceEnabled").val() == 'true';
      this.membershipData = membershipData;
      this.validationRules();
      this.maskInput();
      verification.init();

      this.authToken = $('[name=authToken]').val();
      
      if(!helper.isQuickMembership && $('#auto-renew-payment').length === 0) {
    	  TokenGateway.refreshGateway(); 
      }
      /**
       * Binding header and footer links for leave page modal
       * for given action, depending if it is purchase or renewal flow
       */
      COSTCO.util.activateKeyboardAccesiblePopover('co-help');
      console.log('Renew Membership module initialized');
      
      if(!$("#autoRenewConsentOptionDiv").is(":hidden") && $('input[name="ftc-click-to-enrole"]').length > 0){
		if (!$('input[type="radio"][name="ftc-click-to-enrole"]:checked').val()) {
	      COSTCO.RenewMembership.autoRenew.noConsentInfo();
	    }else {
	      $('input[type="radio"][name="ftc-click-to-enrole"]:checked').trigger('click');
	    }
	  }
      
      reloadSessionJS();
      
      
    },
    autoRenew: {

      /**
       * Constants
       */
      constants: {
        modeType: {
          ADD: 'ADD_MODE',
          EDIT: 'EDIT_MODE',
        },
        
        autoRenewCardBinRangeRegexPattern: '',
        testAutoRenewExpirationDateEnabled: false,
        testAutoRenewExpirationDate: '',
      },
      /**
       * Setting autoRenewCardBinRangeRegexPattern variable
       * @param {String} binRange - bin range that is stored in XAPPLICATION table
       * @return {void}
       */
      setAutoRenewCardBinRange: function(binRange) {
    	  RenewMembership.autoRenew.constants.autoRenewCardBinRangeRegexPattern = new RegExp(binRange);
      },
      /**
       * Setting testAutoRenewExpirationDateEnabled and testAutoRenewExpirationDate variable
       * @param {String} testAutoRenewExpirationDateEnabled and testAutoRenewExpirationDate - stored in XAPPLICATION table
       * @return {void}
       */
      setTestAutoRenew: function(testAutoRenewExpirationDateEnabled, testAutoRenewExpirationDate) {
    	  RenewMembership.autoRenew.constants.testAutoRenewExpirationDateEnabled = testAutoRenewExpirationDateEnabled;
    	  RenewMembership.autoRenew.constants.testAutoRenewExpirationDate = testAutoRenewExpirationDate;
      },
      /**
       * Hide section with last name and zip code for validate membership
       * @return {void}
       */
      hideValidationFieldsForValidatedUser: function() {
    	  if(sessionStorage.getItem("changeValidationFlag")  != "true"){
    		  $('#vallidation-questions').removeClass('hide');
    	  } else {
    		  $('#vallidation-questions').addClass('hide');
    	  }
      },
      validateLastNameZipCode: function () {
    	  let questionLastName = $("#validationQuestionLastName");
          const lastName = $.trim(questionLastName.val());
      	  isLastNameValid = false;
          if (lastName !== undefined && lastName !== '') {
        	  questionLastName.parent()[0].classList.remove("mdc-text-field--invalid");
        	  questionLastName[0].classList.remove("highlightError");
              
        	  questionLastName.removeProp('required');
        	  questionLastName.parent()[0].nextElementSibling.children[0].innerHTML = "";
        	  questionLastName.parent()[0].nextElementSibling.style.display = 'none';
              isLastNameValid =  true;
          }else{
        	  questionLastName.parent()[0].classList.add('mdc-text-field--invalid');
        	  questionLastName[0].classList.add('highlightError');
        	  questionLastName.prop('required', true);
        	  questionLastName.parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_LASTNAME;
        	  questionLastName.parent()[0].nextElementSibling.style.display = 'block';
        	  questionLastName.focus();
              isLastNameValid =  false;
          }        
          let questionZip = $("#validationQuestionZip");
          const zipCode = $.trim(questionZip.val());
      	  isZipValid = false;	
          if (zipCode !== undefined && zipCode !== '' && (COSTCO.util.POSTAL_CODE_REGEX_CA).test(zipCode)) {
              questionZip.parent()[0].classList.remove("mdc-text-field--invalid");
              questionZip[0].classList.remove("highlightError");
              questionZip.removeProp('required');
              questionZip.parent()[0].nextElementSibling.children[0].innerHTML = "";
              questionZip.parent()[0].nextElementSibling.style.display = 'none';
              isZipValid = true;
          } else {
              questionZip.parent()[0].classList.add('mdc-text-field--invalid');
              questionZip[0].classList.add('highlightError');
              questionZip.prop('required', true);
              questionZip.parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_ENTER_ZIPCODE;
              questionZip.parent()[0].nextElementSibling.style.display = 'block';
              if (isLastNameValid) {
                  questionZip.focus();
              }
              isZipValid = false;
          }
          return isZipValid && isLastNameValid;
      },

      /**
       * Add card for auto renew payment. Added check for zipcode and lastname to be sure user is valid and
       * check if user has attempted to enter wrong parameters more times than allowed. 
       * @param  {HTMLFormElement} form form Auto renew payment form
       * @return {void}      [description]
       */
      addCard: function(form) {
        
    	$form = $(form);
    	
    	let displayMode = $form.find('input[id="displayMode"]').val();
    	
    	
    	if($("#ftc-click-to-enrole").prop('checked') == false && displayMode == 'add'){
      		$("#ftc-enrole").addClass("critical-notification");
      		return;
  		} else {
  			$("#ftc-enrole").removeClass("critical-notification");
  		}

        let sessionId = $form.find('input[id="tokenSessionId"]').val();
        
        let lastName = $form.find('input[id="questionLastName"]').length > 0 ? $form.find('input[id="questionLastName"]').val() : '';
        let zipCode = $form.find('input[id="questionZip"]').length > 0 ? $form.find('input[id="questionZip"]').val() : '';
        
        

        let isAddAutoRenew = displayMode == 'add' ? true : false; // Default value
        let isAddAutoRenewConsent = displayMode == 'add' ? true : false; // Default value
        
        let isAutoRenewSelected = $form.find('input[id="cardForAutorenew"]');
        if (isAutoRenewSelected.length == 1) {
          isAddAutoRenew = $form.find('input[id="cardForAutorenew"]').prop('checked');
        }

        let cardHolderName = $form.find('input[id="cc_nameoncard"]').val();

        let expDate = $form.find('input[id="cc_expiry_date"]').val().split('/');

        let expMonth;
        let expYear;
        if (expDate.length == 2) {
          expMonth = expDate[0];
          expYear = `20${expDate[1]}`;
        }
        let data = {};

        if($('input[name="ftc-click-to-enrole"]').length > 0) {
	        data = {
	          'action': 'create_token',
	          'sessionId': sessionId,
	          'isAddAutoRenew': isAddAutoRenew,
	          'autoRenewConsent':isAddAutoRenewConsent,
	          'cardHolderName': cardHolderName,
	          'expiryMonth': expMonth,
	          'expiryYear': expYear,
	          'authToken': RenewMembership.authToken,
	        };
        } else {
        	data = {
  	          'action': 'create_token',
  	          'sessionId': sessionId,
  	          'isAddAutoRenew': isAddAutoRenew,
  	          'cardHolderName': cardHolderName,
  	          'expiryMonth': expMonth,
  	          'expiryYear': expYear,
  	          'authToken': RenewMembership.authToken,
  	        };
        }

        if(sessionStorage.getItem("changeValidationFlag")  !== "true" && membershipData.validated && !membershipData.verified ){
        	let url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', { 
                lastName: $('#validationQuestionLastName').val().trim(),
                zipCode: $('#validationQuestionZip').val().trim(),
            });
            
            
            COSTCO.MemberVerification.submitRequest(url)
                .then((data) => {
                	// Check if user entered invalid parameters more times than allowed
    	            if(data.memberAccountRecordCheckMaxAttempsReached != 'true') {	
    	            	// Check if user is valid and proceed to add the card
    		            if(data.memberAccountRecordMatch == 'true'){
    		            	sessionStorage.setItem("changeValidationFlag", true);
    		            	TokenGateway.updateSessionFromForm('card', function() {
    		                    data.payMethodId = $('input[name=payMethodId]').val();
    		                    if(RenewMembership.cybersourceEnabled) {
    		                    	data.sessionId = $form.find('input[id="tokenSessionId"]').val();
    		                    	data.number = $form.find('input[id="number"]').val();
    		                    }
    		            		RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
    		            		window.digitalDataEvents = window.digitalDataEvents || [ ];
    		            		digitalDataEvents.push( {ui:"Account | Renew Membership | Add Payment Method" } );
    		            		if($('input[name="ftc-click-to-enrole"]').length > 0) {
    		            			digitalDataEvents.push( {renewAuto:"Enrolled" } );
    		            		}
    		      	        }, $form.attr('id'));
    		            } else {
    		            	// Error message if user is not valid
    		            	$('#account-renew-check-error-wrapper').removeAttr('hidden');
    		            	// clear payment info
    		            	$('#card_number').val('');
    		            	$('#cc_expiry_date').val('');
    		            	$('#cc_nameoncard').val('');
    		            	$('#cc_nameoncard_label').removeClass('active');
    		            	TokenGateway.refreshGateway();
    		            	COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, '#account-renew-check-error-wrapper', 'span');
    		            }
                	} else {
                		// Error message if user has entered invalid parameters more times than allowed in previous 24h.
                		$('#account-renew-check-error-wrapper').removeAttr('hidden');
                		$('#renew-validate-membership').addClass('hidden');
                		COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, '#account-renew-check-error-wrapper', 'span');
                		$('.renew-membership-form-and-text').hide();
                	}
            }); 

        } else {
        	TokenGateway.updateSessionFromForm('card', function() {
              data.payMethodId = $('input[name=payMethodId]').val();
              if(RenewMembership.cybersourceEnabled) {
            	  data.sessionId = $form.find('input[id="tokenSessionId"]').val();
            	  data.number = $form.find('input[id="number"]').val();
              }
  	          RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
  	          window.digitalDataEvents = window.digitalDataEvents || [ ];
  	          digitalDataEvents.push( {ui:"Account | Renew Membership | Add Payment Method" } );
	  	      if($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == '') {
	    			digitalDataEvents.push( {renewAuto:"Enrolled" } );
	    	  }
  	        }, $form.attr('id'));
     	    
        }
        
      },

      /**
       * cancel add another card
       */
      cancelAddCard: function(form){
          $('#add-another-card-form').empty();
          $('#add-another-card-form').hide();
          $('#add-another-card-link').show();
          
          if($('#selectedCardForAutoRenew').val() == ''){
        	  $('#saveAutoRenewSettingBtn').show();
        	  $('#cancelAutoRenewBtn').hide();
          } else {
        	  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        	  const cardCheckboxes = Array.from(checkboxes).filter(checkbox => 
	  	  	    checkbox.name.startsWith("cardForAutorenew_"+$('#selectedCardForAutoRenew').val()) && $(checkbox).prop("checked") 
	  	  	  );
        	  
        	  if(cardCheckboxes.length){
        		  $('#saveAutoRenewSettingBtn').hide();
        		  $('#cancelAutoRenewBtn').show();
   	  		 } else {
	   	  		$('#saveAutoRenewSettingBtn').show();
	   	  		$('#cancelAutoRenewBtn').hide();
   	  		 }
        	  
          }
      },
      /**
       * Edit auto renew payment info
       * @param  {HTMLFormElement} form   form Auto renew payment form
       * @param  {String} cardId Card id
       * @return {void}
       */
      editCard: function(form, cardId) {
        $form = $(form);

        let sessionId = $form.find('input[id="tokenSessionId"]').val();

        let isAddAutoRenew = $('input[name="ftc-click-to-enrole"]').length > 0 ? false : true; // Default value
        let isAutoRenewSelected = $form.find('input[id="cardForAutorenew"]');
        if (isAutoRenewSelected.length == 1) {
          isAddAutoRenew = $form.find('input[id="cardForAutorenew"]').prop('checked');
        }

        let cardHolderName = $form.find('input[id="cc_nameoncard"]').val();

        let expDate = $form.find('input[id="cc_expiry_date"]').val().split('/');
        

        let number = $form.find('input[id="card_number"]').val();

        let expMonth;
        let expYear;
        if (expDate.length == 2) {
          expMonth = expDate[0];
          expYear = `20${expDate[1]}`;
        }

        let data = {};
        if($('input[name="ftc-click-to-enrole"]').length > 0) {
        	if($("#ftc-click-to-enrole").prop('checked') != true && $('#selectedCardForAutoRenew').val() == cardId){
	        	util.notification.clearNotification($('#auto-renew-notification'));
	  		  	util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.AUTO_RENEW_CONSENT_INFORMATION_ERROR], true, $('#auto-renew-notification'), 'div');
	  		  	$('#auto-renew-notification').addClass('cds-u-space-mb-md');
	  		  	$('#auto-renew-notification').show();
	  		    $('#auto-renew-notification').focus();
	  		  	return;
        	} else if ($('#selectedCardForAutoRenew').val() != cardId) {
        		data = {
      		          'action': 'update_token',
      		          'sessionId': sessionId,
      		          'memberCreditAccountId': cardId,
      		          'isAddAutoRenew': false,
      		          'autoRenewConsent': false,
      		          'cardHolderName': cardHolderName,
      		          'expiryMonth': expMonth,
      		          'expiryYear': expYear,
      		          'authToken': RenewMembership.authToken,
      		          'number': number,
      		        };
        	} else {
        		isAddAutoRenew = true;
	        	data = {
		          'action': 'update_token',
		          'sessionId': sessionId,
		          'memberCreditAccountId': cardId,
		          'isAddAutoRenew': isAddAutoRenew,
		          'autoRenewConsent':isAddAutoRenew && $("#ftc-click-to-enrole").prop('checked') && $('#selectedCardForAutoRenew').val() != '',
		          'cardHolderName': cardHolderName,
		          'expiryMonth': expMonth,
		          'expiryYear': expYear,
		          'authToken': RenewMembership.authToken,
		          'number': number,
		        };
        	}
        } else {
        	data = {
	          'action': 'update_token',
	          'sessionId': sessionId,
	          'memberCreditAccountId': cardId,
	          'isAddAutoRenew': isAddAutoRenew,
	          'cardHolderName': cardHolderName,
	          'expiryMonth': expMonth,
	          'expiryYear': expYear,
	          'authToken': RenewMembership.authToken,
	          'number': number,
	        };
        }

        TokenGateway.updateSessionFromForm('card', function() {
          data.payMethodId = $('input[name=payMethodId]').val();
          if(RenewMembership.cybersourceEnabled) {
        	  data.sessionId = $form.find('input[id="tokenSessionId"]').val();
        	  data.number = $form.find('input[id="number"]').val();
          }
          
          RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
          window.digitalDataEvents = window.digitalDataEvents || [ ];
          digitalDataEvents.push( {ui:"Account | Renew Membership | Update Payment Method" } );
          if($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
  			digitalDataEvents.push( {renewAuto:"Enrolled" } );
          }
        }, $form.attr('id'));
      },

      /**
       * Cancel update on canceling update of paymenr method for auto renew
       * @param  {string} formType	Form type to show (add_another | edit)
       * @param  {number} cardId 		Card id
       * @return {void}
       */
      cancelUpdate: function(formType, cardId) {
          $(`#auto-payment-item-${cardId}`).removeClass('hide');
          $(`#auto-payment-form-item-${cardId}`).html('');
          if($('#selectedCardForAutoRenew').val() == ''){
        	  $('#saveAutoRenewSettingBtn').show();
        	  $('#cancelAutoRenewBtn').hide();
          } else {
        	  $('#saveAutoRenewSettingBtn').hide();
        	  $('#cancelAutoRenewBtn').show();
          }
          $('#auto-renew-notification').hide();
          if($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId){
    		  $('#autoRenewConsentOptionDiv').hide();
    		  $('#ftc-enrole-information').hide();
    		  
    	  }
      },
      /**
       * Remove credit card for auto renew
       * @param {string} bodyMessage 	To be displayed in modal
       * @param {string} cardId   			Card id to delete
       */
      deleteCard: function(bodyMessage, cardId) {
    	  //remove add another form and show add another link
          $('#add-another-card-link').show();
          $('#add-another-card-form').empty();
          //remove update form and display update remove links opened for update
          $('[data-card-id]').each(function(index, value) {
              $value = $(value);
              let currentId = $value.attr('data-card-id');
              $(`#auto-payment-item-${currentId}`).removeClass('hide');
              $(`#auto-payment-form-item-${currentId}`).empty();
          });

    	 if(RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
             return;
         } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
        	 // last name and zip code is not valid, show validation prescreen
             COSTCO.MembershipValidation.showValidationPrescreen();
       	  	return;
         }
        COSTCO.dialog.createExtDialogBox({
          title: messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVE_CARD,
          body: bodyMessage,
          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVE_CARD,
          secondary: messages.JS_DIALOG_CANCEL,
          dialogclasses: 'remove-card-modal',
          primary_event: function() {
        	  let data = {};
              if($('input[name="ftc-click-to-enrole"]').length > 0) {
            	  if($('#selectedCardForAutoRenew').val() == cardId){
            		  data = {
	    				  'action': 'delete_token',
	    				  'autoRenewConsent':false,
	    		          'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	    		          'authToken': RenewMembership.authToken,
	    		        };
            	  } else {
            		  data = {
			              'action': 'delete_token',
			              'memberCreditAccountId': cardId,
			              'autoRenewConsent': $('#selectedCardForAutoRenew').val() != '',
			              'authToken': RenewMembership.authToken,
			            };
            	  }
              }else {
            	  data = {
		              'action': 'delete_token',
		              'memberCreditAccountId': cardId,
		              'authToken': RenewMembership.authToken,
		            };
              }

            RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
            window.digitalDataEvents = window.digitalDataEvents || [ ];
            digitalDataEvents.push( {ui:"Account | Renew Membership | Remove Payment Method" } );
  	      	if($('#selectedCardForAutoRenew').val() == cardId){
  	      		digitalDataEvents.push( {renewAuto:"Not Enrolled" } );
  	      	}
  	      	
            COSTCO.dialog.close();
          },
        });
      },
      
      /**
       * Sets card for auto renew (on / off)
       * @param {Element} element Input element to get if user has checked for autorenew
       * @param {string} cardId  Card id to update
       */
      setAsDefaultAutoRenew: function(element, cardId, hasPayer) {
    	  if(event.type == 'click' || (event.type == 'keydown' && event.code == 'Space')){
	    	  if($('#add-another-card-form').is(":visible")){
	    		  $('#add-another-card-form').hide();
	    		  $('#saveAutoRenewSettingBtn').show();
	    	  }
	    	  if($('#add-another-card-link').is(":hidden")){
	    		  $('#add-another-card-link').show();
	    	  }
	    	  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
		  	  const cardCheckboxes = Array.from(checkboxes).filter(checkbox => 
		  	    checkbox.name.startsWith("cardForAutorenew_"+cardId)
		  	  );
		  	  const otherCardCheckboxes = Array.from(checkboxes).filter(checkbox => 
		  	  	checkbox.name.startsWith("cardForAutorenew_") && !checkbox.name.startsWith("cardForAutorenew_"+cardId)
		  	  );
	    	  if(RenewMembership.autoRenew.hasUserReachedMaxAttempts() || !RenewMembership.autoRenew.isValidMembershipInfo() || $('input[name="ftc-click-to-enrole"]').length > 0 ) {
	    		  
	    		  if($('#selectedCardForAutoRenew').val() == cardId){
	    			  
	    			  if(($(window).width() > 1024 && cardCheckboxes[1].checked) || ($(window).width() < 1024 && !cardCheckboxes[0].checked)){
	    				  $('#saveAutoRenewSettingBtn').show();
	       	  	    	  $('#cancelAutoRenewBtn').hide();
	       	  	      } else {
	       	  	    	  $('#saveAutoRenewSettingBtn').hide();
	       	  	    	  $('#cancelAutoRenewBtn').show();
	       	  	      }
	    			  
	    			  $('#autoRenewConsentOptionDiv').hide();
	        		  $('#ftc-enrole-information').hide();
	        		  
	    		  }else {
	    			  $('#autoRenewConsentOptionDiv').show();
	    			  $('#saveAutoRenewSettingBtn').show();
	        		  $('#cancelAutoRenewBtn').hide();
	        		  $('#ftc-enrole-information').show();
	    		  }
	    		  if(!RenewMembership.autoRenew.isValidMembershipInfo()){
	    			  COSTCO.MembershipValidation.showValidationPrescreen();
	    		  }
	    		  
	    		  if(cardCheckboxes.length){
	     	  		 if($(window).width() > 1024 && cardCheckboxes[1].checked){
	     	  			$("[id='cardForAutorenew_"+cardId+"']").prop("checked",false);
	     	  		 } else if($(window).width() > 1024 && !cardCheckboxes[1].checked){ 
	     	  			$("[id='cardForAutorenew_"+cardId+"']").prop("checked",true);
	     	  		 } else if($(window).width() < 1024 && cardCheckboxes[0].checked){ 
	     	  			$("[id='cardForAutorenew_"+cardId+"']").prop("checked",true);
	     	  		 } else if($(window).width() < 1024 && !cardCheckboxes[0].checked){ 
	     	  			$("[id='cardForAutorenew_"+cardId+"']").prop("checked",false);
	     	  		 }
	     	  		 if(otherCardCheckboxes.length){
	     	  			otherCardCheckboxes.forEach(item => {
	     	  			  $(item).prop("checked",false);
	     	  			});
	     	  		 }
	     	  		 
	     	  	 } 
	    		  
	      		return;
	          }
	    	  if($('input[name="ftc-click-to-enrole"]').length == 0) {
		    	  if (typeof(hasPayer) == 'undefined' &&  !element.checked ) {
		            element.checked = true;
		
		            COSTCO.dialog.createExtDialogBox({
		              title: messages.ACCOUNT_RENEW_MEMBERSHIP_USE_CARD_FOR_AUTO_RENEW,
		              body: messages.ACCOUNT_RENEW_MEMBERSHIP_USE_CARD_FOR_AUTO_RENEW_DEFAULT_TEXT,
		              primary: messages.JS_DIALOG_YES,
		              secondary: messages.JS_DIALOG_NO,
		              dialogclasses: 'remove-card-modal',
		              primary_event: function() {
		                  let data = {
		                  'action': 'delete_renew',
		                  'memberCreditAccountId': cardId,
		                  'authToken': RenewMembership.authToken,
		                };
		        
		                RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
		                COSTCO.dialog.close();
		              },
		              secondary_event: function() {
		                $("[id='cardForAutorenew_"+cardId+"']").prop("checked",true);
		                COSTCO.dialog.close();
		              },
				        });
		          } else {
		            let data = {
		              'action': 'add_renew',
		              'memberCreditAccountId': cardId,
		              'authToken': RenewMembership.authToken,
		            };
		            RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data); 
		          }
	    	  } 
    	  }

      },
      
      /**
       * enroll auto renew 
       */
      enroll: function(displayMode) {
    	  $('#cancelAutoRenewBtn').hide();
    	  $('#displayAddEditCards').show();
    	  if(displayMode == 'add'){
    		  $('#saveAutoRenewSettingBtn').hide();
    	  }
    	  if(displayMode == 'edit' && $('#cardForAutorenew_'+$('#selectedCardForAutoRenew').val()).prop('checked') == true ){
    		  RenewMembership.showCreditCardForm('edit',$('#selectedCardForAutoRenew').val(), RenewMembership.renewCreditCardData);
    		 
    		  $('#autoRenewConsentOptionDiv').show();
    		  $('#ftc-enrole-information').show();
    		  $('#saveAutoRenewSettingBtn').hide();
        	  $('#cancelAutoRenewBtn').hide();
    	  }

      },
      
      noConsentInfo:function() {
    	  
    	  if($('#selectedCardForAutoRenew').val() == ''){
    		  $('#displayAddEditCards').hide();
    		  $('#saveAutoRenewSettingBtn').show();
    		  $('#cancelAutoRenewBtn').hide();
    		  $('#autoRenewConsentOptionDiv').show();
    		  $('#ftc-enrole-information').show();
    	  } else {
    		  $('#displayAddEditCards').show();
    		  $('#saveAutoRenewSettingBtn').hide();
    		  $('#cancelAutoRenewBtn').show();
    		  $('#autoRenewConsentOptionDiv').hide();
    		  $('#ftc-enrole-information').hide();
    	  }
    	  $('#auto-renew-notification').hide();
    	  
    	  
      },
      
      /**
       * unenroll auto renew 
       */
      unenroll: function(displayMode) {
    	  $('#displayAddEditCards').hide();
    	  $('#saveAutoRenewSettingBtn').show();
    	  $('#cancelAutoRenewBtn').hide();
    	  if(displayMode == 'add'){
	    	  $('#card_number').val('');
	      	  $('#cc_expiry_date').val('');
	      	  $('#cc_nameoncard').val('');
	      	  $('#cc_nameoncard_label').removeClass('active');
	      	  reloadSessionJS();
    	  }
    	  
    	  if(displayMode == 'edit' && $('#cardForAutorenew_'+$('#selectedCardForAutoRenew').val()).prop('checked') == true ){
    		  
    		  RenewMembership.autoRenew.cancelUpdate(RenewMembership.getForm(),$('#selectedCardForAutoRenew').val());
    		  
    		  $('#autoRenewConsentOptionDiv').show();
    		  $('#ftc-enrole-information').show();
    		  $('#saveAutoRenewSettingBtn').show();
        	  $('#cancelAutoRenewBtn').hide();
    	  }
      },
      
      cancelAutoRenew: function(){
    	  
    	  if(RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
              return;
          } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
         	 // last name and zip code is not valid, show validation prescreen
              COSTCO.MembershipValidation.showValidationPrescreen();
        	  	return;
          }
    	  let data = {
			  'action': 'delete_renew',
			  'autoRenewConsent':false,
	          'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	          'authToken': RenewMembership.authToken,
	        };
		  RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
		  $('#auto-renew-notification').show();
		  $('#auto-renew-notification').focus();
		  window.digitalDataEvents = window.digitalDataEvents || [ ];
		  digitalDataEvents.push( {renewAuto:"Not Enrolled" } );
      },
      
      /**
       * save auto renew settings 
       */
      saveAutoRenewSettings: function() {
    	  
    	  if(RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
              return;
          } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
         	 // last name and zip code is not valid, show validation prescreen
              COSTCO.MembershipValidation.showValidationPrescreen();
        	  	return;
          }
    	  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
	  	  const selectedCheckboxes = Array.from(checkboxes).filter(checkbox => 
	  	    checkbox.checked && checkbox.name.startsWith("cardForAutorenew_")
	  	  );
	  	  const renewCardCheckboxes = Array.from(checkboxes).filter(checkbox => 
	  	  	!checkbox.checked && checkbox.name.startsWith("cardForAutorenew_"+$('#selectedCardForAutoRenew').val())
	  	  );
    	  if($("#ftc-click-to-enrole").prop('checked') == true){
    		if(selectedCheckboxes.length){
    			let firsSelected = selectedCheckboxes[0];
    			let firstSelectedSplited = firsSelected.id.split('_');
    			if(firstSelectedSplited.length && firstSelectedSplited.length >1){
    				let selectedCardId = firstSelectedSplited[1];
    				let data = {
    	    	              'action': 'add_renew',
    	    	              'autoRenewConsent':true,
    	    	              'memberCreditAccountId': selectedCardId,
    	    	              'authToken': RenewMembership.authToken,
    	    	            };
    				$('#ftc-enrole-error').addClass('hide');
        			$("#ftc-enrole > label.control > div.control__indicator").removeClass("critical");
    	    	    RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
    	    	    $('#auto-renew-notification').show();
    	    	    $('#auto-renew-notification').focus();
    	    	    window.digitalDataEvents = window.digitalDataEvents || [ ];
    	    	    digitalDataEvents.push( {ui:"Account | Renew Membership | Save Payment Method Auto Renew Settings" } );
    	    	    digitalDataEvents.push( {renewAuto:"Enrolled" } );
    			}
    		} else {
    			$('#auto-renew-notification').hide();
    			$('#ftc-enrole-error').removeClass('hide');
    			$('#ftc-enrole-error').focus();
    			$("#ftc-enrole > label.control > div.control__indicator").addClass("critical");
    		}
    	  } else if($("#ftc-click-to-enrole-not").prop('checked') == true || (renewCardCheckboxes.length && !selectedCheckboxes.length && $('#selectedCardForAutoRenew').val() != "") ){
    		 
			  let data = {
				  'action': 'delete_renew',
				  'autoRenewConsent':false,
                  'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
                  'authToken': RenewMembership.authToken,
                };
			  RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
			  $('#auto-renew-notification').show();
			  $('#auto-renew-notification').focus();
			  window.digitalDataEvents = window.digitalDataEvents || [ ];
			  digitalDataEvents.push( {ui:"Account | Renew Membership | Save Payment Method Auto Renew Settings" } );
			  digitalDataEvents.push( {renewAuto:"Not Enrolled" } );
    		 
    	  }else {
    		  util.notification.clearNotification($('#auto-renew-notification'));
    		  util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.AUTO_RENEW_CONSENT_INFORMATION_ERROR], true, $('#auto-renew-notification'), 'div');
    		  $('#auto-renew-notification').addClass('cds-u-space-mb-md');
    		  $('#auto-renew-notification').show();
    		  $('#auto-renew-notification').focus();
    	  }
      },
      /**
       * Add placeholder on expiration date 
       * @return void
       */
      addPlaceHolder: function(expirationDate) {
      	expirationDate.placeholder = "MM/YY";
      },
      /**
       * Remove placeholder on expiration date 
       * @return void
       */
      removePlaceHolder: function(expirationDate) {
    	if(expirationDate && expirationDate.value === ''){
    		$("label[for='" + $(expirationDate).attr('id') + "']").removeClass('active');
    		expirationDate.placeholder = "";
    	}
      },
      services: {
        /**
         * Ajax modular service for handling auto renew payment
         * @param  {object} data   JSON Object to be sent to backend
         */
        ajaxManageAutoRenewPayment: function(data) {
          util.notification.clearNotification($('#auto-renew-notification'));
          $('#auto-renew-notification').removeClass('cds-u-space-mb-md');
          RenewMembership.validateStorePaymentForm();
          let form = RenewMembership.getForm();
          if (form.valid()) {
            $('.gw-proxy-number').removeClass('card-number-error');

            let autoRenewAction = data.action;
            let autoRenewCardUpdate = data.memberCreditAccountId == $('#selectedCardForAutoRenew').val();
            
            COSTCO.Checkout.ajax_update_state({
              method: 'POST',
              url: '/AjaxManageAutoRenewPayment',
              data: data,
              dataType: 'json',
              done: function(data, textStatus, jqXHR, options) {
                // Reset content of Top Notification if user is Business membership eligible for renewal
                if ($('#business-primary-top-notification').length) {
                	util.notification.displayNotification(util.notification.type.WARNING, [$('#business-primary-top-notification').text().trim()]);
                }
                if (data != undefined) {
                  if (data.error.application.length > 0) {
                	  util.notification.displayNotification(util.notification.type.ERROR, data.error.application, true, $('#auto-renew-notification'), 'div');
                	  $('#auto-renew-notification').addClass('cds-u-space-mb-md');
                	  if($('input[name="ftc-click-to-enrole"]').length > 0){
                		  if($("#ftc-click-to-enrole").prop('checked') == true){
                			  $("#ftc-enrole > label.control > div.control__indicator").addClass("critical");
                		  }else if($("#ftc-click-to-enrole-not").prop('checked') == true){
                			  $("#ftc-enrole-not > label.control > div.control__indicator").addClass("critical");
                		  }
                	  }
                  } else {
                	  if(typeof(data.payload.data.maxAttemptReached) !== 'undefined' && data.payload.data.maxAttemptReached === true){
                		  $('#notification-max-attempt-reached').removeClass('hidden');
                		  return;
                	  }
                	  COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
                	  if(typeof(data.payload.data.autoRenewSuccess) !== 'undefined' && data.payload.data.autoRenewSuccess === 'true') {
                		  let currentDate = new Date();
                      	  let expirationDate;
                      	  let billingDate;
                      	  let twoDayesBefooreBilling;
                    	  
                      	  if(COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDateEnabled === 'true' && COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDate !== 'undefined'){
                      		  expirationDate = new Date(COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDate);
                      	  }else{
                      		  expirationDate = new Date(membershipData.caller.expireDate.year.value, parseInt(membershipData.caller.expireDate.month.value)-1, membershipData.caller.expireDate.day.value, 0, 0, 0, 0);
                      	  }
                      	  billingDate = new Date(expirationDate);
                      	  //billingDate.setMonth(billingDate.getMonth() -1);
                      	  
                      	  twoDayesBefooreBilling = new Date(billingDate);
                      	  twoDayesBefooreBilling.setDate(twoDayesBefooreBilling.getDate() - 2);

                		  let notificationStatus;
                		  let notificationMessage;
                		  switch(autoRenewAction) {
                		  	case 'delete_renew': 
                		  		if($('input[name="ftc-click-to-enrole"]').length > 0){
                		  			notificationStatus = COSTCO.util.notification.type.SUCCESS;
                		  		} else {
                		  			notificationStatus = COSTCO.util.notification.type.WARNING;
                		  		}
                		  		if(currentDate.getTime() < twoDayesBefooreBilling.getTime()){
                		  			notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW;
	  	                    	} else if(currentDate.getTime() < billingDate.getTime()){
	  	                    		notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_AFTER_BILLING;
	  	                    	} else {
	  	                    		notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_ON_BILLING;
	  	                    	}
                		  		break;
                		  	case 'delete_token':
                		  		  if($('input[name="ftc-click-to-enrole"]').length > 0 && autoRenewCardUpdate){
                		  			  notificationStatus = COSTCO.util.notification.type.SUCCESS;
                		  		  } else if ($('input[name="ftc-click-to-enrole"]').length > 0 && !autoRenewCardUpdate) {
                		  			notificationStatus = "";
                		  		  } else {
                		  			  notificationStatus = COSTCO.util.notification.type.WARNING;
                		  		  }
	                		  	  if(currentDate.getTime() < twoDayesBefooreBilling.getTime()){
	                		  			notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW;
		  	                      } else if(currentDate.getTime() < billingDate.getTime()){
		  	                    		notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_AFTER_BILLING;
		  	                      } else {
		  	                    		notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_ON_BILLING;
		  	                      }
                		  	  
	                        	  break;
                          	default:
                          	  if ($('input[name="ftc-click-to-enrole"]').length > 0 && !autoRenewCardUpdate && autoRenewAction == 'update_token') {
                          		notificationStatus = "";
                          		notificationMessage = "";
                          	  } else if(currentDate.getTime() < twoDayesBefooreBilling.getTime()){
	                    		  notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                    		  notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW;
	                    	  } else if(currentDate.getTime() < billingDate.getTime()){
	                    		  notificationStatus = COSTCO.util.notification.type.WARNING;
	                    		  notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW_TWO_DAYS_BEFORE_BILLING;
	                    	  } else {
	                    		  notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                    		  notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW_AFTER_BILLING;
	                    	  }
                          }
                		  if(notificationStatus && notificationMessage) {
	                		  util.notification.displayNotification(notificationStatus, [notificationMessage], true, $('#auto-renew-notification'), 'div');
	                		  $('#auto-renew-notification').addClass(' cds-u-space-mt-md cds-u-space-mb-md');
	                		  $('#auto-renew-notification').show();
	                		  $('#auto-renew-notification').focus();
                		  }
                	  }
                  }
                  $('input[type="radio"][name="ftc-click-to-enrole"]:checked').trigger('click');
                }
                TokenGateway.refreshGateway();
              },
            });
          }
        },
      },
      /**
       * Opens Add Card dialog when membership is payed by someone else
       * @param  {[type]} mode [description]
       * @return {void}      [description]
       */
      openHasPayerAddCardDialog: function(mode) {
        let settings = {
          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Add_Card_Dialog_Title_Text,
          body: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Add_Card_Dialog_Body_Text,
          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Add_Card_Button_Text,
          secondary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Cancel_Button_Text,
          secondary_event: function() {
            COSTCO.dialog.close();
          },
        };
        if (mode == this.constants.modeType.ADD) {
          settings.primary_event = function() {
            COSTCO.RenewMembership.autoRenew.addCard($('#StorePaymentForm'));
            COSTCO.dialog.close();
          };
        } else if (mode == this.constants.modeType.EDIT) {
          settings.primary_event = function() {
            COSTCO.RenewMembership.showCreditCardForm('add_another');
            COSTCO.dialog.close();
          };
        }
        COSTCO.dialog.createExtDialogBox(settings);
      },
      /**
       * Opens Use Card dialog when membership is payed by someone else
       * @param  {[type]} memberCreditAccountId [description]
       * @return {void}                       [description]
       */
      openHasPayerUseCardDialog: function(memberCreditAccountId) {
        let settings = {
          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Use_Card_Dialog_Title_Text,
          body: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Use_Card_Dialog_Body_Text,
          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Use_Card_Button_Text,
          secondary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Cancel_Button_Text,
          primary_event: function() {
            COSTCO.RenewMembership.autoRenew.setAsDefaultAutoRenew($('#cardForAutorenew_' + memberCreditAccountId), memberCreditAccountId, true);
            COSTCO.dialog.close();
          },
          secondary_event: function() {
            COSTCO.dialog.close();
          },
        };
        COSTCO.dialog.createExtDialogBox(settings);
      },

      /**
      * Validation to check if user already filled membership info before any action for auto renew.
      * If not valid, dialog form will be shown
      */
      validateMembershipInfo: function() {
        if (!sessionStorage.getItem("changeValidationFlag")) {
          COSTCO.MembershipValidation.showValidationPrescreen();
          return false;
        }
        return true;
      },

      /**
       * Validation to check if user already filled membership info before any action for auto renew.
       */
      isValidMembershipInfo: function() {
         return (membershipData.verified || sessionStorage.getItem("changeValidationFlag"));
       },
      /**
      * Check if user has reached max attempts to update payment info for renew membership.
      * Needed for popup validation (check function "validateMembershipInfo")
      * @returns boolean
      */
     hasUserReachedMaxAttempts: function() {
       return $("#maxAttemptRetriesReached").val() === "true";
     }

    },

    /**
     * The interface to remove an affiliate from the "Renew Membership"
     * feature (/RenewMembershipView) for business members.
     * @param  {Number} affiliateMembershipNumber The affiliate's membership num
     * @return {void}
     */
    removePerson: function(affiliateMembershipNumber, isQuickMembership) {
      let affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
      if(isQuickMembership !== undefined && isQuickMembership !== ''){
    	  helper.isQuickMembership = isQuickMembership;
      }
      // This is necessary because affForm.removePerson is expecting an object
      // thats tied to how the membership application "configProduct" represents
      // that affiliate, this will normalize that.
      affiliate = {
        membershipNumber: affiliate.cardNumber.value,
        firstName: affiliate.firstName.value,
        lastName: affiliate.lastName.value,
      };
      affForm.removePerson({
        affiliate: affiliate,
        isRenew: true,
        excludeData: true,
        action: 'remove-affiliate',
        isQuickMembershipCheckout: helper.isQuickMembership,
      });
    },
    /**
     * The interface to remove an affiliate household from the "Renew Membership"
     * feature (/RenewMembershipView) for business members.
     * @param  {Number} affiliateMembershipNumber The affiliate's membership num
     * @return {void}
     */
    removePersonHousehold: function(affiliateMembershipNumber) {
      let affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
      // This is necessary because affForm.removePerson is expecting an object
      // thats tied to how the membership application "configProduct" represents
      // that affiliate, this will normalize that.
      affiliate = {
        membershipNumber: affiliate.cardNumber.value,
        firstName: affiliate.firstName.value,
        lastName: affiliate.lastName.value,
        houseHold: {
          membershipNumber: affiliate.household.cardNumber.value,
          firstName: affiliate.household.firstName.value,
          lastName: affiliate.household.lastName.value,
        },
      };
      affForm.removePerson({
        affiliate: affiliate,
        isRenew: true,
        excludeData: true,
        action: 'remove-household',
      });
    },
    /**
     * Add an affiliate using /MemberAffiliateAddCmd
     * @method
     * @return {void}
     */
    addPerson: function() {
      affForm.openAddPersonModal({
        isRenew: true,
      });
    },
    /**
     * Add a person to a household as part of ther renew membership flow.
     * @param  {Number} membershipNumber The Affiliate membershipNumber
     * @return {void}
     */
    addPersonWithinHousehold: function(membershipNumber) {
      let affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, membershipNumber);
      affForm.editPerson({
        affiliate: affiliate,
        action: 'update',
        addHousehold: true,
        isRenew: true,
      });
    },
    /**
     * Validation rules
     * @return {void} [description]
     */
    validationRules: function() {
      $.validator.addMethod('membershipNumber', function(value, element) {
        return /^\d{12,16}$/.test(value);
      }, messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberInvalid_Text);

      $.validator.addMethod('customcc', function(value, element) {
        value = value.replace(/\s+/g, '');
        if (value.indexOf('*') > 0 && value.length == 16) {
          return true;
        }
        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.creditcard.call($.data(element.form, 'validator'), value, element);
      });

      $.validator.addMethod('autorenewcostcocc', function(value, element) {
   	    return this.optional(element) || /^(2|4|5)/.test(value);
      });
      
      $.validator.addMethod('cobrandedcard', function(value, element) {
    	return RenewMembership.autoRenew.constants.autoRenewCardBinRangeRegexPattern.test(value);
      });

      $.validator.addMethod('checkSpecialchar', function(value, element) {
        return this.optional(element) || !(/[<>\'\"]/).test(value); // CC name shouldn't have any html tag
      });

      $.validator.addMethod('checkExpiryDate', function(value, element) {
        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
      });

      $.validator.addMethod('checkIsDateInPast', function(value, element ) {
		let enteredMonth = parseInt(value.split('/')[0]);
		let enteredYear = parseInt(value.split('/')[1]);
		let now = new Date();
		let currentMonth = parseInt((now.getMonth() + 1).toString());
		let currentYear = parseInt(now.getFullYear().toString().substr(-2));
		if (enteredYear < currentYear || (enteredYear == currentYear && enteredMonth < currentMonth)) {
		  return false;
		} else{
		  return true;
		}
      });
      $.validator.addMethod('checkZipCode', function(value, element) {
    	  const zipCode = $.trim($('#validationQuestionZip').val());
    	  var langId = COSTCO.util.getLangId();
    	  var regex = COSTCO.util.POSTAL_CODE_REGEX_US;
    	  if (parseInt(langId) === -24 || parseInt(langId) === -25) {
			regex = COSTCO.util.POSTAL_CODE_REGEX_CA;
    	  }

    	  return (zipCode !== undefined && zipCode !== '' && regex.test($.trim(value)));
      });
    },

    /**
     * Checks renewal date
     * @return {void} [description]
     */
    checkRenewalDate: function() {
    	util.notification.clearNotification();
      if (this.validateCheckRenewalDateForm()) {
        COSTCO.Checkout.ajax_update_state({
          method: 'POST',
          url: '/AjaxMembershipCheckRenewalDateCmd',
          data: $('#check-renewal-date').serialize(),
          dataType: 'json',
          done: function(data, textStatus, jqXHR, options) {
            let returnData = data.payload.data;
            let statusReason = returnData.membershipStatusReason;
            if (!returnData.isMembershipNumberValid) {
            	util.notification.displayNotification(util.notification.type.ERROR, [messages.MEMBERVERIFICATION_MEMBERSHIP__InfoDoesNotMatchOurRecords]);
            } 
            else {
	            if (returnData.maxAttemptReached) {
	              util.notification.displayNotification(util.notification.type.ERROR, [messages.MEMBERSHIP_UnverifiedRenewal_MaxAttemps]);
	            } else if (statusReason != '' && statusReason != 'Z10' && statusReason != 'Z24') {
	              // If we're not active ("" || Z10) or Expired (Z24), can't
					// renew online.
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['You\'re unable to renew online, please visit a warehouse.']);
	            } else {
	              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
				}
            }
          },
          always: function() {
            $('.order-ajax').removeClass('ajax-busy');
          },
        });
      }
    },
    /**
     * Mask expiry date
     * @return {void} [description]
     */
    maskInput: function() {
      $('#cc_expiry_date').mask('00/00', {
      });
      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
        selectOnFocus: true,
        translation: {
          'Z': {
            pattern: '[\\*0-9]',
          },
        },
      });
      var langId = COSTCO.util.getLangId();
      if (parseInt(langId) === -24 || parseInt(langId) === -25) {
          $('#validationQuestionZip').unmask().mask('S0S 0S0');
        } else {
          $('#validationQuestionZip').unmask().mask('00000');
       }
    },
    /**
     * Validates CheckRenewalDate form
     * @return {[type]} [description]
     */
    validateCheckRenewalDateForm: function() {
      $('#check-renewal-date').validate({
        rules: {
          memberLastNameToRenew: {
            required: true,
          },
          membershipNumberToRenew: {
            required: {
              depends:function(){
                $(this).val($.trim($(this).val()));
                return true;
              }
            },
            membershipNumber: true,
          },
        },
        messages: {
          memberLastNameToRenew: {
            required: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_LastNameMissing_Text,
          },
          membershipNumberToRenew: {
            required: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberMissing_Text,
            membershipNumber: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberInvalid_Text,
          },
        },
      });
      return $('#check-renewal-date').valid();
    },
    /**
     * Manage payment method
     * @param  {string} action   action type (delete_renew | delete_token | )
     * @param  {[type]} memberCreditAccountId   [member card account id]
     * @return {void}
     */
    managePaymentMethods: function(action, memberCreditAccountId) {
      COSTCO.Checkout.ajax_update_state({
        method: 'POST',
        url: '/AjaxManageAutoRenewPayment',
        data: {
          'action': action,
          'memberCreditAccountId': memberCreditAccountId,
          'authToken': RenewMembership.authToken,
        },
        dataType: 'json',

        done: function(data, textStatus, jqXHR, options) {
        	util.notification.clearNotification();

          if (data != undefined) {
            if (data.error.application.length > 0) {
            	util.notification.displayNotification(util.notification.type.ERROR, data.error.application);
            } else {
              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
            }
          }
        },
        always: function(data, textStatus, jqXHR, options) {
          $('.order-ajax').removeClass('ajax-busy');
          // location.reload();
        },
      });
    },
    /**
     * Validates the Payment Methods add/edit form
     * @return {void}
     */
    validateStorePaymentForm: function() {
      let form = RenewMembership.getForm();
      let isCreditCardNumberValidationRequired = false;
      //validate cc number when adding new card. Also validate on update card if cc number is changed:
      if (displayMode.value.indexOf('add')>=0 || (displayMode.value.indexOf('edit') >=0 && !$('#card_number').val()))
    	  isCreditCardNumberValidationRequired = true;
      form.validate({
        rules: {
          cc_nameoncard: {
        	required: true,
            checkSpecialchar: true,
          },
          cc_expiry_date: {
            required: true,
            checkExpiryDate: true,
            checkIsDateInPast: true,
          },
          questionLastName: {
        	required: true,
          },
          questionZip: {
        	required: true, 
        	checkZipCode: true,
          },
        },
        messages: {
          number: {
            required: messages.ERR_CCNUM_REQ,
            customcc: messages.ERR_INVALID_CREDITCARD_SHORT,
            autorenewcostcocc: messages.MEMBERSHIP_RENEW__ERR_INVALID_CCNUM_AUTO_RENEW,
            cobrandedcard: messages.ERR_COBRANDED_CREDITCARD,
          },
          cc_nameoncard: {
        	required: messages.ERR_INVALID_CC_NAME,
            checkSpecialchar: messages.ERR_INVALID_CC_NAME,
          },
          cc_expiry_date: {
            required: messages.ERR_EXPIRYDATE_REQ,
            checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
            checkIsDateInPast: messages.ERR_INVALID_PAST_DATE,
          },
          questionLastName: {
        	required: messages.ERR_INVALID_LASTNAME,
          },
          questionZip: {
        	required: messages.ERR_ENTER_ZIPCODE_NEW,
          	checkZipCode: messages.ERR_ENTER_ZIPCODE,
          },
        },
        errorPlacement: function(error, element) {
          if (element.is('#card_number_validator')) {
            $('.gw-proxy-number').css('border', '');
            $('.gw-proxy-number').addClass('card-number-error');
            error.insertAfter(element);
          } else {
            error.insertAfter(element);
          }
        },
      });

      if (form.length != 0) {
        return form.valid();
      }
    },
    /**
     * Shows credit card form on the page, and hides all other opened credit card forms
     * @param  {string} formType	Form type to show (add_another | edit)
     * @param  {number} cardId 		Card id
     * @param  {[type]} data [description]
     * @return {void}
     */
    showCreditCardForm: function(formType, cardId, data) {
	  if(membershipData.validated == true && membershipData.verified == false){
		if(RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
			return;
		}else if (!RenewMembership.autoRenew.isValidMembershipInfo()){
			// last name and zip code is not valid, show validation prescreen
			COSTCO.MembershipValidation.showValidationPrescreen();
			return;
		}
	  }
      let formHtmlBlock;
      let template = `tmpl_auto_renew_membership_${formType}`;
      if(!this.cybersourceEnabled || formType === 'add_another') {
    	  createTokenSessionId('true');
      }
      //}
      $('#saveAutoRenewSettingBtn').hide();
      $('#cancelAutoRenewBtn').hide();
      $('#auto-renew-notification').hide();
      if (formType === 'add_another') {
        $('#add-another-card-link').hide();
        formHtmlBlock = '#add-another-card-form';
      } else if (formType === 'edit') {
    	  if($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId){
    		  $('#autoRenewConsentOptionDiv').show();
    		  $('#ftc-enrole-information').show();
    		  RenewMembership.renewCreditCardData = data;
    	  } else {
    		  $('#autoRenewConsentOptionDiv').hide();
    		  $('#ftc-enrole-information').hide();
    	  }
        $('#add-another-card-link').show();
        $('#add-another-card-form').empty();
        $(`#auto-payment-item-${cardId}`).addClass('hide');
        formHtmlBlock = `#auto-payment-form-item-${cardId}`;
      } else {
        return;
      }
      $('[data-card-id]').each(function(index, value) {
        $value = $(value);
        let currentId = $value.attr('data-card-id');
        if (formType === 'add_another') {
            $(`#auto-payment-item-${currentId}`).removeClass('hide');
            $(`#auto-payment-form-item-${currentId}`).html('');
        }
        if (formType === 'edit' && currentId !== cardId) {
            $(`#auto-payment-item-${currentId}`).removeClass('hide');
            $(`#auto-payment-form-item-${currentId}`).html('');
        }
        if ($value.attr('data-type') == 'display') {
          if (currentId == cardId) {
            $value.hide();
          } else {
            $value.show();
          }
        } else if ($value.attr('data-type') == 'form') {
          if (currentId == cardId) {
            formHtmlBlock = `#${$value.attr('id')}`;
          } else {
            $value.empty();
          }
        }
      });

      let htmlForm = COSTCO.util.tmpl(template, data);
      $(formHtmlBlock).html(htmlForm);
      $(formHtmlBlock).show();
      
      if(this.cybersourceEnabled) {
	      this.setInputFieldsEvents();
      } else {
    	  TokenGateway.reloadOnInitialize = true;
	      TokenGateway.refreshGateway();
      }
      this.maskInput();
    },
    setInputFieldsEvents: function() {
    	$("#card_number").keypress(function(){
    		TokenGateway.resetCardNumber(this);
    	}).keyup(function(event){
    		if(event.keyCode === 8 || event.keyCode === 46){
    			TokenGateway.resetCardNumber(this);
    		}
    	});
    	$("#card_number").click(function(){
    		TokenGateway.resetCardNumber(this);
    	});
    },
    upgradeBusinessOnclickEvent: function() {
      // Set some state to signify the user wants to upgrade. This will tell
      // the application to use the renewAndUpgrade price returned from CRM
      // after any CRUD operation.
      this.isUpgrading = true;
      // Show the user a notification about how they need to upgrade in addition
      // to renewing.
      util.notification.displayNotification(util.notification.type.WARNING, [
        `${$('#businessPrimaryExpiryInfoText').text()} ${$('#businessForcedRenewalUpgradeText').text()}`,
      ]);
      // Update the total price using the "renewAndUpgradeAmount".
      helper.updateTotalPrice(this.membershipData, true);
      // Show the business executive specific details
      $('#membership-tier-price .affiliate-primary').addClass('hide');
      $('#membership-tier-price .affiliate-primary.upgrade').removeClass('hide');
      // Switch the add to cart link to business executive
      $('#renew-button').attr('onclick', $('[data-renew-upgrade]').data('renew-upgrade'));
     
    },

    upgradeGoldStarOnclickEvent: function() {
      // If you're renew eligible then you are sold a upgraded renewal instead of an upgrade to the current account
	  if(membershipData.caller.renewEligible) {
		  addUpgradeMembershipToCart('GoldStarExecutive',false);
	  }else{
		  addUpgradeMembershipToCart('GoldStarUpgrade',true);
	  }
	  window.digitalDataEvents = window.digitalDataEvents || [ ];
	  digitalDataEvents.push( {nav:"Account | Membership | Upgrade Membership" } )
    },
    /**
     * Reverts the radio selection on Quick Renew Post Lockdown page
     * @return void
     */
    revertRadioSelection: function(isUpgrade) {
    	$('#renew-membership-block, #upgrade-membership-block').toggleClass('radio-selected-background');
    	if (isUpgrade) {
    		$('#radio-renew-membership').prop('checked', true);
    	} else {
    		$('#radio-upgrade-membership').prop('checked', true);
    	}
    },
    
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.RenewMembership = RenewMembership;
  return RenewMembership;
});



// WEBPACK FOOTER //
// ./js/account/renew-membership.js